module.exports = __webpack_public_path__ + "media/images/table-084a3ffe4c5ed15150a8cd6c60b0893d.jpg";